import { Language, SIMULATION_VOICE } from "@/types/language";
import { create } from "zustand";

export const AUDIO_STATE = {
  MUTE: "MUTE",
  UNMUTE: "UNMUTE",
  PAUSE: "PAUSE",
  RESUME: "RESUME",
  STOP: "STOP",
} as const;

interface AudioState {
  audioVoice: string;
  audioState: string;
  setMute: () => void;
  setUnmute: () => void;
  setPause: () => void;
  setResume: () => void;
  setStop: () => void;
  clearAudioState: () => void;
  setVoice: (voicePath: string) => void;
  getVoiceName: (code: string) => string;
}

export const useAudioStore = create<AudioState>()((set, get) => ({
  audioVoice: SIMULATION_VOICE[0].code,
  audioState: "",
  setMute: () => set({ audioState: AUDIO_STATE.MUTE }),
  setUnmute: () => set({ audioState: AUDIO_STATE.UNMUTE }),
  setResume: () => set({ audioState: AUDIO_STATE.RESUME }),
  setPause: () => set({ audioState: AUDIO_STATE.PAUSE }),
  setStop: () => set({ audioState: AUDIO_STATE.STOP }),
  clearAudioState: () => set({ audioState: "" }),
  setVoice: (voice) => set({ audioVoice: voice }),
  getVoiceName: (code: string) => {
    const language = SIMULATION_VOICE.find(
      (lang: Language) => lang.code === code
    );
    return language?.name || "";
  },
}));
